// extracted by mini-css-extract-plugin
var _1 = "o-nav-buttons";
var _2 = "o-step-foooter";
export { _1 as "o-nav-buttons", _2 as "o-step-foooter" }
